import { isFunction } from '@/utils/is'

function stopPropagation(ev) {
  ev.stopPropagation()
}

/**
 * 用于处理dom的"外部"事件
 * modifiers的`key`就是事件名称,会阻止本组件`key`事件冒泡,document会接收`key`事件; fn为处理的函数
 * example: <div v-outside.click.mousedown="fn" />
 */
export const OutSideDirective = {
  /**
     *
     * @param {import('vue').default} Vue
     */
  install(Vue) {
    Vue.directive('outside', {
      bind(el, binding) {
        const fn = binding.value
        if (isFunction(fn)) {
          const modifiers = binding.modifiers
          for (const key in modifiers) {
            el.addEventListener(key, stopPropagation, false)
            document.addEventListener(key, fn, false)
          }
        }
      },
      unbind(el, binding) {
        const fn = binding.value
        if (isFunction(fn)) {
          const modifiers = binding.modifiers
          for (const key in modifiers) {
            el.removeEventListener(key, stopPropagation)
            document.removeEventListener(key, fn)
          }
        }
      }
    })
  }
}
